import { composeFetch, RequestConfig } from '@library/http'
import {
  addPath,
  composeRequest,
  setHeader,
  setMethod,
  setQueryParams,
  setServiceUrl,
} from '@library/http/requests'
import { extractSidesResponse } from './deserialisers'

type SidesRequestParams = {
  limit?: string
  periodId?: string
  recipes: string[]
}

const sidesRequest = composeRequest(
  setServiceUrl('products', 2),
  addPath('sides'),
  setQueryParams(({ limit, periodId }: SidesRequestParams) => ({
    limit: limit ?? '5',
    ...(periodId && { period_id: periodId }),
  })),
  setHeader('Content-Type', 'application/json'),
  setMethod('POST'),
  (req: RequestConfig, input: SidesRequestParams) => {
    req.body = JSON.stringify({ recipes: input.recipes })

    return req
  },
)

export const sidesFetcher = composeFetch(sidesRequest, extractSidesResponse)
